/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { SELECTED_MENU_INITIAL_STATE } from 'utils/const';

// ------------------------------------
// State
// ------------------------------------

const initialState = {
  loggedIn: false,
  me: {},
  selectedNavMenu: SELECTED_MENU_INITIAL_STATE,
};

// ------------------------------------
// Slices
// -----------------------------------

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    loggedInSuccessfully: (state, action) => {
      state.loggedIn = true;
      state.me = action.payload;
    },
    logInErrored: (state) => {
      state.loggedIn = false;
      state.me = {};
    },
    loggedOutSuccessfully: (state) => {
      state.loggedIn = false;
      state.me = {};
    },
    setSelectedNavMenu: (state, action) => ({
      ...state,
      selectedNavMenu: action.payload,
    }),
  },
});

// ------------------------------------
// Exports
// ------------------------------------

export default appSlice.reducer;
export const {
  loggedInSuccessfully,
  logInErrored,
  loggedOutSuccessfully,
  setSelectedNavMenu,
} = appSlice.actions;
